import React, { useEffect } from 'react';
import { useNavigate } from "react-router"

// Material UI
import { Grid, IconButton, Paper, Tooltip, Typography } from "@mui/material"
import { Receipt } from "@mui/icons-material"

// Components
import { DataGrid, ViewButton } from '@arredo/reactjs-ui';
import InvoiceFilters from "../../components/invoice/filters"

// Hooks
import useQueryString from "../../hooks/queryString/useQueryString"
import useInvoices from '../../hooks/invoices/useInvoices'
import useStyles from './styles'
import useUser from '../../hooks/user/useUser';

import { channels } from '../../models/Channels'
import { GetInvoiceTypeByCountry } from "../../models/EnumEntity"
import { title, columns } from "../../models/InvoiceEntity"

const getDefaultFilters = (isFranchise) => ({
    pageSize: 10,
    pageNumber: 1,
    channel: isFranchise ? channels.values.Franchises : channels.values.Tienda
})

const Invoices = () => {
    const { branch, business } = useUser();
    const { classes } = useStyles();
    const { setParameterSearch, filters, clearFilters } = useQueryString();
    const { invoices, totalPage, loading } = useInvoices(filters);
    const push = useNavigate();

    useEffect(() => {
        if (business) {
            setParameterSearch({...getDefaultFilters(business.isFranchise)});
        }
    }, [business]);

    const handleChangePage = (e, page) =>
        setParameterSearch({
            ...filters,
            pageNumber: Number(page)
        });

    return (
        <Grid container spacing={1}>
            <Grid size={12}>
                <Paper className={classes.paper}>
                    <Typography align="center" variant="h4">
                        {title}
                    </Typography>
                </Paper>
            </Grid>
            <Grid size={12}>
                <InvoiceFilters
                    filters={filters}
                    clearFilters={clearFilters}
                    setFilters={setParameterSearch}
                    valuesTypeSelect={GetInvoiceTypeByCountry(branch.country)}
                    isInvoice
                />
            </Grid>
            <Grid size={12}>
                <DataGrid
                    columns={columns}
                    loading={loading}
                    rows={invoices}
                    actions={
                        ({ row }) => (
                            <>
                                <ViewButton
                                    to={`/cashRegisters/invoices/${row.id}`}
                                />

                                <Tooltip title='Ver Orden'>
                                    <IconButton
                                        color='primary'
                                        onClick={() => push(`/orders/detail/${row.externalId}`)}
                                        size="large"
                                    >
                                        <Receipt />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )
                    }
                    paginationProps={{
                        count: totalPage,
                        page: Number(filters?.pageNumber || 1),
                        onChange: handleChangePage
                    }}
                />
            </Grid>
        </Grid>
    );
}
export default Invoices